import { useEffect } from "react";

import { Box, FormControl, Typography, Select } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const GroupedQuestions = ({ label, sections, questions, value, onChange }) => {
  const { getMessage, getLabel } = useLocalization();

  const getId = (obj) => obj?.id || obj?._id;

  const uniqueSections = Array.isArray(sections)
    ? sections.filter((section, index, array) => {
        const sectionId = getId(section);
        if (!sectionId) return false;

        return index === array.findIndex((item) => getId(item) === sectionId);
      })
    : [];

  const uniqueQuestions = Array.isArray(questions)
    ? questions.filter((question, index, array) => {
        const questionId = getId(question);
        if (!questionId) return false;

        return index === array.findIndex((item) => getId(item) === questionId);
      })
    : [];

  useEffect(() => {
    // console.log({ questions });
    // console.log({ sections });
  }, []);

  return (
    <Box width="100%">
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>
      <FormControl fullWidth>
        <Select
          native
          id="questionList"
          fullWidth
          size="small"
          value={value ? value : ""}
          onChange={(e) => onChange(e.target.value)}
          sx={{
            fontSize: "12px",
          }}
        >
          <option value="notset">{getMessage("notSet")}</option>
          {uniqueSections.map((section) => (
            <optgroup
              label={section.name}
              key={getId(section)}
            >
              {uniqueQuestions
                .filter((question) => {
                  const questionSectionId =
                    question.surveySectionId || question.surveysectionid;
                  return questionSectionId === getId(section);
                })
                .map((item) => (
                  <option
                    key={getId(item)}
                    value={getId(item)}
                  >
                    {item.name}
                  </option>
                ))}
            </optgroup>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default GroupedQuestions;
